import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    email: localStorage.getItem("userEmail") || "",
  }),
  actions: {
    setEmail(email) {
      this.email = email;
      localStorage.setItem("userEmail", email);
    },
    clearEmail() {
      this.email = "";
      localStorage.removeItem("userEmail");
    },
  },
});
